var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content ht-100v pd-0"},[_c('main-header',{attrs:{"txt":"Тээврийн хэрэгсэл / Товчоодын нэвтрэлт"}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-body"},[_c('div',{staticClass:"container pd-0-f"})])
}]

export { render, staticRenderFns }